import { Button, Pagination, Space, Table, Tooltip } from 'antd';
import { ColumnsType } from 'antd/es/table';
import React, { useState } from 'react';
import { PaginationProps } from 'antd/lib/pagination';
import { CONSTANT } from '../../../../config/Constant';
import { EyeOutlined, DeleteOutlined } from '@ant-design/icons';
import ViewReport from './ViewReport';
import DeleteReport from './DeleteReport';
import ExportCSVReport from '../../../../components/ExportCSVReport';
import { titleCase } from '../../../../config/Global';

interface DataType {
  index: number;
  id: string | any;
  phone_number: string;
  number_type: string;
  state: string;
  payment_type: string;
  service_type: string;
  subscription_type: string;

  response: string;
  created_date: string | any;
}

const ListTable: React.FC<any> = (props) => {
  const {
    listData,
    setListData,
    totalData,
    tableloading,
    setTableLoading,
    paginationData,
    setPaginationData,
    getList,
    savePayload,
  } = props;

  const [openUpdateModal, setOpenUpdateModal] = useState<boolean>(false);
  const [openUpdateData, setOpenUpdateData] = useState<any>();
  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
  const [openDeleteData, setOpenDeleteData] = useState<any>();

  const handleDeleteRequest = (record: any) => {
    setOpenDeleteModal(!openDeleteModal);
    setOpenDeleteData(record);
  };

  const handleDeleteRequestClose = (record: any) => {
    setOpenDeleteModal(false);
    setOpenDeleteData({});
  };

  const columns: ColumnsType<DataType> = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 80,

      sortDirections: ['descend', 'ascend'],
      sorter: (a, b) => a.id.toString().localeCompare(b.id),
    },
    {
      title: 'Phone Number',
      dataIndex: 'phone_number',
      key: 'phone_number',
      width: 180,

      sortDirections: ['descend', 'ascend'],
      sorter: (a, b) => a.phone_number.localeCompare(b.phone_number),
      render: (_, record) => {
        return record?.phone_number && titleCase(record?.phone_number);
      },
      fixed: 'left',
    },
    {
      title: 'Number Type',
      key: 'number_type',
      dataIndex: 'number_type',
      width: 200,
      fixed: 'left',
      sortDirections: ['descend', 'ascend'],
      sorter: (a, b) => a.number_type.localeCompare(b.number_type),
      render: (_, record) => {
        return record?.number_type && titleCase(record?.number_type);
      },
    },
    {
      title: 'State',
      dataIndex: 'state',
      key: 'state',
      width: 180,

      sortDirections: ['descend', 'ascend'],
      sorter: (a, b) => a.state.localeCompare(b.state),
      render: (_, record) => {
        return record?.state && titleCase(record?.state);
      },
      fixed: 'left',
    },
    {
      title: 'Payment Type',
      dataIndex: 'payment_type',
      key: 'payment_type',
      width: 180,

      sortDirections: ['descend', 'ascend'],
      sorter: (a, b) => a.payment_type.localeCompare(b.payment_type),
      render: (_, record) => {
        return record?.payment_type && titleCase(record?.payment_type);
      },
      fixed: 'left',
    },
    {
      title: 'Service Type',
      dataIndex: 'service_type',
      key: 'service_type',
      width: 180,

      sortDirections: ['descend', 'ascend'],
      sorter: (a, b) => a.service_type.localeCompare(b.service_type),
      render: (_, record) => {
        return record?.service_type && titleCase(record?.service_type);
      },
      fixed: 'left',
    },
    {
      title: 'Subscription Type',
      dataIndex: 'subscription_type',
      key: 'subscription_type',
      width: 180,

      sortDirections: ['descend', 'ascend'],
      sorter: (a, b) => a.subscription_type.localeCompare(b.subscription_type),
      render: (_, record) => {
        return (
          record?.subscription_type && titleCase(record?.subscription_type)
        );
      },
      fixed: 'left',
    },
    {
      title: 'Response',
      dataIndex: 'response',
      key: 'response',
      width: 180,

      sortDirections: ['descend', 'ascend'],
      sorter: (a, b) => a.response.localeCompare(b.response),
      render: (_, record) => {
        return record?.response && titleCase(record?.response);
      },
      fixed: 'left',
    },
    {
      title: 'Created Date',
      dataIndex: 'created_date',
      key: 'created_date',
      width: 180,

      sortDirections: ['descend', 'ascend'],
      sorter: (a, b) =>
        (a?.created_date || '').localeCompare(b?.created_date || ''),
      render: (_, record) => {
        return record?.created_date ? record?.created_date : '-';
      },
    },
    {
      title: 'Action',
      key: 'action',
      width: 200,
      // fixed: 'right',
      render: (_, record) => {
        const viewData = record?.response ? JSON.parse(record?.response) : null;

        return (
          <Space size='middle'>
            <Tooltip title={'Delete Report'}>
              <Button
                onClick={() => {
                  handleDeleteRequest(record);
                }}
                icon={<DeleteOutlined />}
                type='default'
                className='cancelBtn iconBtn'
              />
            </Tooltip>
            {/* <Tooltip title={'Delete Report'}>
                <Button
                  type='default'
                  icon={<DeleteOutlined />}
                  className='cancelBtn'
                  onClick={() => handleDeleteRequest(record)}>
                  Delete
                </Button>
              </Tooltip> */}
          </Space>
        );
      },
    },
  ];

  const numberAttributesData: DataType[] = listData?.map((item, index) => ({
    key: index.toString(),
    index: item.index,
    id: item._id,
    row_id: item._id,
    phone_number: item.phone_number,
    number_type: item.number_type,
    state: item.state,
    payment_type: item.payment_type,
    service_type: item.service_type,
    subscription_type: item.subscription_type,
    response: item?.response,
    created_date: item?.created_date,
  }));

  const handleChange: PaginationProps['onChange'] = (current, page_size) => {
    setListData([]);
    setTableLoading(true);
    setPaginationData({
      current: current,
      page_size: page_size,
    });
    const updateData = {
      ...savePayload,
      current: current,
      page_size: page_size,
    };
    getList(updateData);
  };

  const onShowSizeChange: PaginationProps['onShowSizeChange'] = (
    current,
    page_size,
  ) => {
    setListData([]);
    setTableLoading(true);
    setPaginationData({
      current: current,
      page_size: page_size,
    });
    const updateData = {
      ...savePayload,
      current: current,
      page_size: page_size,
    };
    getList(updateData);
  };

  const handleViewReport = (data: any) => {
    setOpenUpdateModal(!openUpdateModal);
    setOpenUpdateData(data);
  };

  return (
    <>
      <div className='responsiveTable'>
        <Table
          dataSource={numberAttributesData}
          columns={columns}
          pagination={false}
          loading={tableloading}
        />
        <div className='text-center mt-20 mb-30 providerTable'>
          <Pagination
            defaultCurrent={1}
            current={paginationData?.current}
            total={totalData ?? 0}
            onChange={handleChange}
            responsive={true}
            pageSize={paginationData?.page_size}
            // showSizeChanger={totalData ? true : false}
            showSizeChanger
            onShowSizeChange={onShowSizeChange}
            pageSizeOptions={CONSTANT.PER_PAGE_RECORD}
          />
        </div>
      </div>

      {openUpdateModal && (
        <ViewReport
          openUpdateModal={openUpdateModal}
          openUpdateData={openUpdateData}
          handleViewReport={handleViewReport}
        />
      )}

      <DeleteReport
        // title={openDeleteData?.id}
        title={'Report'}
        close={handleDeleteRequestClose}
        open={openDeleteModal}
        deleteValues={openDeleteData?.row_id}
        getList={getList}
      />
    </>
  );
};
export default ListTable;
